import { memo, createRef, MouseEvent, KeyboardEvent, FunctionComponent, InputHTMLAttributes } from 'react';

import { HistorySearchItem } from './index';

// Styles
import styles from './Style.module.scss';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory } from '@fortawesome/free-solid-svg-icons';

interface Input extends InputHTMLAttributes<HTMLInputElement> {
    onChooseSearch: (term: string) => void;
    listHistorySearch: Array<HistorySearchItem>;
    onDeleteHistory: (event: MouseEvent<HTMLSpanElement>, id: string) => void;
}

const InputSearch: FunctionComponent<Input> = memo(
    ({ listHistorySearch, className, onChooseSearch, onDeleteHistory, ...props }) => {
        const inputRef = createRef<HTMLInputElement>();

        const handleChooseSearch = (term: string) => {
            inputRef.current.value = term;
            onChooseSearch(term);
        };

        const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
            if (event.code === 'Enter' || event.charCode === 13) {
                inputRef.current.blur();
            }
        };

        const renderSearchHistory = () => {
            return listHistorySearch?.map((item, index) => (
                <li
                    className={styles.item_history_search}
                    onClick={() => handleChooseSearch(item.term)}
                    key={`search-history-item-${item.id}-${index}`}
                >
                    <FontAwesomeIcon className={styles.icon_history} icon={faHistory} />
                    {item.term}
                    <span onClick={(event) => onDeleteHistory(event, item.id)} className={styles.btn_delete}>
                        Xoá
                    </span>
                </li>
            ));
        };

        return (
            <div className={className}>
                <input
                    {...props}
                    type="text"
                    ref={inputRef}
                    onKeyPress={handleKeyPress}
                    className={styles.input_search}
                />

                {listHistorySearch?.length > 0 && (
                    <ul className={styles.history_search_wrapper}>{renderSearchHistory()}</ul>
                )}
            </div>
        );
    },
);

InputSearch.defaultProps = {
    className: '',
};

export default InputSearch;
